export default {
  data() {
    return {
      selectedRows: [],
      selectAllIndeterminate: false,
    }
  },
  computed: {
    hasSelection() {
      return this.selectedRows.length > 0
    },
    selectedIds() {
      return this.selectedRows.map((r) => this.getRowSelectionKey?.(r) || r.salesInvoiceId || r.id)
    },
    selectionCount() {
      return this.selectedRows.length
    },
    isAllSelected() {
      if (!this.selectableRows?.length) return false
      return this.selectedRows.length === this.selectableRows.length
    },
    isIndeterminate() {
      if (!this.selectableRows?.length) return false
      return this.selectedRows.length > 0 && !this.isAllSelected
    },
    selectableRows() {
      const rows = Array.isArray(this.einvoiceList) ? this.einvoiceList : []
      return rows.filter((row) => {
        // Hard gate: rows with contractInvalid=true are never selectable
        if (row && row.contractInvalid) return false
        return this.isRowSelectable ? this.isRowSelectable(row) : true
      })
    },
  },
  watch: {
    selectedRows: {
      handler() {
        this.selectAllIndeterminate = this.isIndeterminate
      },
      deep: true,
    },
  },
  methods: {
    clearSelection() {
      this.selectedRows = []
      this.selectAllIndeterminate = false
      if (this.$refs?.invoiceTable?.clearSelected) {
        this.$refs.invoiceTable.clearSelected()
      }
    },
    onRowSelected(rows) {
      const nextRows = Array.isArray(rows) ? rows : []
      this.selectedRows = nextRows.filter((row) => {
        // Hard gate: rows with contractInvalid=true are never selectable
        if (row && row.contractInvalid) return false
        return this.isRowSelectable ? this.isRowSelectable(row) : true
      })
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedRows = []
      } else {
        this.selectedRows = [...this.selectableRows]
      }
    },
  },
}
